import { HeaderProvider } from 'hooks/useHeader';
import React, { PropsWithChildren, Suspense } from 'react';
import { Switch } from 'react-router';

const HeaderLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <HeaderProvider>
      <Suspense fallback={<></>}>
        <Switch>{children}</Switch>
      </Suspense>
    </HeaderProvider>
  );
};

export default HeaderLayout;
